import { Tag, TagLeftIcon, TagLabel } from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";

const InterestBadge = ({text}) => {
    return (
        <Tag 
            size={'lg'} 
            variant='subtle' 
            colorScheme='cyan'
            bg="cyan.50"
            color="cyan.700"
            border="1px solid"
            borderColor="cyan.200"
        >
            <TagLeftIcon boxSize='12px' as={AddIcon} color="cyan.600" />
            <TagLabel>{text}</TagLabel>
        </Tag>
    );
}

export default InterestBadge;